import { render } from "./App.vue?vue&type=template&id=0300ada2&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\dmart\\Desktop\\Mi codigo\\maneiros_v2\\dotaappnofactu\\jano\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__